import css from './BasicTableHeader.module.css';
import classNames from 'classnames';

export interface HeaderCell {
    title: string;
    width: string;
}

interface ItemTypesTableHeaderProps {
    headerCells: HeaderCell[];
    headerExtraClassName?: string;
    cellExtraClassName?: string;
}

export const BasicTableHeader: React.FC<ItemTypesTableHeaderProps> = ({
    headerCells,
    headerExtraClassName,
    cellExtraClassName,
}) => {
    return (
        <div className={classNames(css.header, headerExtraClassName)}>
            {headerCells.map((cell, index) => (
                <div
                    key={index}
                    className={classNames(css.cell, cellExtraClassName)}
                    style={{ width: cell.width }}
                >
                    {cell.title}
                </div>
            ))}
        </div>
    );
};
